// Métadonnées des 8 classes du PCG 2025 — Charte institutionnelle KEYTO
// Palette : charcoal (#2A2D34/#474D59) + navy-purple (#15294F/#3B1E6E)
// + blue (#2D6BE0/#5AA0FF) + variantes désaturées par classe.

export const CLASSES = [
  {
    id: 1,
    label: "Comptes de capitaux",
    nature: "Bilan – Passif (principalement)",
    role:
      "Ressources stables de l'entreprise : capital, réserves, résultat, provisions et emprunts à long terme. Ce sont les financements durables qui figurent en haut du passif du bilan.",
    sens_normal: "Créditeur",
    color: { bg: "#EEF2FF", border: "#475569", text: "#15294F", primary: "#2D6BE0" },
    icon: "Building2",
  },
  {
    id: 2,
    label: "Comptes d'immobilisations",
    nature: "Bilan – Actif immobilisé",
    role:
      "Biens durables détenus par l'entreprise : machines, bâtiments, logiciels, titres financiers… Tout ce qui sert l'activité sur plus d'un exercice.",
    sens_normal: "Débiteur (les amortissements 28 et dépréciations 29 sont créditeurs)",
    color: { bg: "#FAF5EF", border: "#475569", text: "#7C3F1D", primary: "#A56A2E" },
    icon: "Factory",
  },
  {
    id: 3,
    label: "Comptes de stocks et en-cours",
    nature: "Bilan – Actif circulant",
    role:
      "Stocks de matières premières, de marchandises, de produits finis et travaux en cours. Mouvementés à l'inventaire (méthode de l'inventaire intermittent) ou en permanence.",
    sens_normal: "Débiteur (39 est créditeur : dépréciations de stocks)",
    color: { bg: "#F0F5F0", border: "#475569", text: "#1F4D3A", primary: "#2F7A5C" },
    icon: "Boxes",
  },
  {
    id: 4,
    label: "Comptes de tiers",
    nature: "Bilan – Créances (actif) et dettes (passif)",
    role:
      "Relations avec les tiers : fournisseurs, clients, État (TVA, IS), personnel, organismes sociaux, associés. Le cœur des opérations quotidiennes.",
    sens_normal: "Débiteur si créance, Créditeur si dette",
    color: { bg: "#FBF1F1", border: "#475569", text: "#7A1F2E", primary: "#A33B4B" },
    icon: "Users",
  },
  {
    id: 5,
    label: "Comptes financiers",
    nature: "Bilan – Trésorerie active et passive",
    role:
      "Banques, caisse, valeurs mobilières de placement, effets, virements internes. Tout ce qui touche à la trésorerie disponible.",
    sens_normal: "Débiteur (sauf 519 concours bancaires)",
    color: { bg: "#EBF1FB", border: "#475569", text: "#15294F", primary: "#2D6BE0" },
    icon: "Wallet",
  },
  {
    id: 6,
    label: "Comptes de charges",
    nature: "Compte de résultat – Débit",
    role:
      "Ce que l'entreprise consomme ou paie pour fonctionner : achats, services extérieurs, salaires, charges sociales, impôts, dotations. Toujours débiteurs.",
    sens_normal: "Débiteur (sens unique)",
    color: { bg: "#FDF3EE", border: "#475569", text: "#7C3A1A", primary: "#B85724" },
    icon: "TrendingDown",
  },
  {
    id: 7,
    label: "Comptes de produits",
    nature: "Compte de résultat – Crédit",
    role:
      "Ce que l'entreprise gagne ou perçoit : ventes de marchandises, prestations, production stockée, subventions, produits financiers. Toujours créditeurs.",
    sens_normal: "Créditeur (sens unique)",
    color: { bg: "#EEF5F2", border: "#475569", text: "#1E5040", primary: "#2F7A5C" },
    icon: "TrendingUp",
  },
  {
    id: 8,
    label: "Comptes spéciaux",
    nature: "Hors bilan / engagements",
    role:
      "Comptes hors bilan utilisés pour suivre les engagements donnés et reçus, ainsi que les opérations particulières.",
    sens_normal: "Variable selon usage",
    color: { bg: "#F1F3F7", border: "#475569", text: "#2A2D34", primary: "#474D59" },
    icon: "Bookmark",
  },
];

export const getClass = (id) => CLASSES.find((c) => c.id === Number(id));

// Palette KEYTO globale (pour usage dans les composants)
export const KEYTO = {
  ink: "#15294F",        // texte principal & ombres
  inkLight: "#2A2D34",
  charcoal: "#474D59",
  navy: "#15294F",
  purple: "#3B1E6E",
  blue: "#2D6BE0",
  blueLight: "#5AA0FF",
  blueGlow: "#3E8BFF",
  bg: "#F8FAFC",
  bgSoft: "#F1F5F9",
  border: "#CBD5E1",
};
